import { StandardEvents } from '@shopify/events';

// Track confirmed additions, including Quick Add and queued variant additions.
// The cart response contains cumulative quantities; use the request's quantities.
document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
  if (event.action !== 'add' || !event.promise) return;
  const lines = (event.lines ?? []).map((line) => ({ ...line }));
  let result;
  try {
    result = await event.promise;
  } catch {
    return;
  }
  const { cart, detail } = result;
  if (detail?.didError || !Array.isArray(detail?.items)) return;

  for (const line of lines) {
    const variantId = String(line.merchandiseId).split('/').pop();
    const item = detail.items.find((item) => String(item.variant_id) === variantId);
    const quantity = Number(line.quantity);
    if (!item || !Number.isFinite(quantity) || quantity <= 0) continue;
    const currency = cart?.cost?.totalAmount?.currencyCode ?? window.Shopify?.currency?.active;
    try {
      if (typeof window.pintrk === 'function' && currency) {
        window.pintrk('track', 'addtocart', {
          product_id: item.sku,
          value: (item.final_price / 100) * quantity,
          currency,
          order_quantity: quantity,
        });
      }
    } catch {
      // A blocked provider must not prevent another provider or affect the cart.
    }

    try {
      const viewedProduct = window.loopsKlaviyoProduct;
      const productData = String(viewedProduct?.ProductID) === String(item.product_id) ? viewedProduct : {
        Name: item.product_title,
        ProductID: item.product_id,
        ImageURL: item.image,
        URL: new URL(item.url, window.location.origin).href,
        Brand: item.vendor,
        Price: item.final_price / 100,
      };
      window._learnq = window._learnq || [];
      window._learnq.push(['track', 'Added to Cart', { ...productData, Quantity: quantity }]);
    } catch {
      // Tracking availability must not affect successful purchases.
    }
  }
});
